import { render, staticRenderFns } from "./Establecimiento.vue?vue&type=template&id=b80ae9de&scoped=true"
import script from "./Establecimiento.vue?vue&type=script&lang=js"
export * from "./Establecimiento.vue?vue&type=script&lang=js"
import style0 from "./Establecimiento.vue?vue&type=style&index=0&id=b80ae9de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80ae9de",
  null
  
)

export default component.exports